"use client";
import { FloatingNav } from "@/components/ui/floating-navbar";
import { IconBriefcase, IconCode, IconHome, IconMail, IconUser } from "@tabler/icons-react";

function Navbar() {
  const navItems = [
    { name: "Home", link: "#home", icon: <IconHome className="h-4 w-4" /> },
    { name: "Experience", link: "#experience", icon: <IconBriefcase className="h-4 w-4" /> },
    { name: "Projects", link: "#projects", icon: <IconCode className="h-4 w-4" /> },
    { name: "About", link: "#about", icon: <IconUser className="h-4 w-4" /> },
  ];

  return (
    <FloatingNav
      navItems={navItems}
      cta={
        <a
          href="#contact"
          className="relative rounded-full bg-white px-4 py-2 text-sm font-medium text-black transition-all hover:bg-neutral-200"
        >
          <span className="flex items-center gap-1">
            <IconMail className="h-4 w-4 sm:hidden" />
            <span className="hidden sm:inline">Contact</span>
          </span>
        </a>
      }
    />
  );
}

export default Navbar;
